/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import Axios from "axios";
import { LOCAL_STORAGE } from "../../config/const";
import APP_CONSTANTS from '../../config/constants';
import EditModal from '../modals/editModal';
import BillPaymentDetailsModal from './billPaymentDetailsModal';
import cogoToast from "cogo-toast";

function IntegratedReferenceNumber(props) {
  const [isSubmited, setIsSubmited] = useState(false)
  const approveBillIntigrate = async () => {
    if(props.data.reloadIntegratedRefNo){
      window.location.reload()
      return;
    }
    setIsSubmited(true)
    const { userId, customerNo, userToken } = LOCAL_STORAGE;
    let data = JSON.stringify
      ({
        customerNo,
        userId,
        "billReferenceNo": props?.data?.refNo
      })
    await Axios.post(
      `${process.env.REACT_APP_BASE_URL}/purchase/bill/approvedBillIntegrateInOracle`, data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      }
    )
      .then((response) => {
        cogoToast.success('Reload Successfully.').then(() => {
          window.location.reload()
        })
      })
      .catch((error) => console.log(error));
  }

  return (
    <>
      {props?.data?.integratedReferenceNumber ? props.data.integratedReferenceNumber : ''}
      {props.data.integratedReferenceNumber == 'Error' ? <>
        <Button /* onClick={handlePayments} */ basic className="w3-tiny ml-2" circular type="button" icon> <Icon name="info" color="grey" size='small' title={props.data.integratedReferenceNumberErrorContent} /></Button>
        {
          LOCAL_STORAGE.customerNo == 1568 ?
            <Button disabled={isSubmited} onClick={() => approveBillIntigrate()} basic className="w3-tiny ml-1" circular type="button" icon> <Icon name="refresh" color="blue" size='small' title={props.data.integratedReferenceNumberErrorContent} /></Button>
            : null
        }
      </> :
        null
      }
    </>
  )
}

export default IntegratedReferenceNumber
